module.exports = "https://cdn.realtymogul.com/static/media/icon_diversification2.67c77101.svg";